import { getCookie } from "@ciaopeople/cp-shatsu/Cookie";
import { isString } from "@ciaopeople/cp-shatsu/TypeChecking";

const GLOBAL_PROPERTY = "_session_funnel_id"
const FUNNEL_COOKIE_NAME = "bFunnel";

function getCookieDomain(host: string): string  {
    const split = host.split(".");
    if(split && split.length >= 2) {
        return split[split.length-2] +  "." + split[split.length-1];
    }
    else return '';
}





export function getFunnelSessionId(): string {

    let session_funnel: string | null =(window && 
                                        GLOBAL_PROPERTY in window &&
                                        isString(window[GLOBAL_PROPERTY]))?
                                        window[GLOBAL_PROPERTY]:null;
    
    if(!session_funnel || session_funnel.trim() == "") {
        session_funnel = getCookie(FUNNEL_COOKIE_NAME);
    }
   
    return session_funnel;
}



